module.exports = __webpack_public_path__ + "sign.png?13c4714d387fec7222a3981b0e1f1c8a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sign.png
// module id = 117
// module chunks = 0